import { ComponentFactory, Injectable, TemplateRef } from '@angular/core';
import { take } from 'rxjs/operators';

import { ConfirmationModalComponent } from '../components/confirmation/confirmation.component';
import {
  overOverlayModalBackdropClass,
  overOverlayModalClass,
} from '../constants/modal-classes';
import { ModalOptions } from '../interfaces/modal-options';

import { ModalService } from './modal.service';

@Injectable()
export class ConfirmationModalService {
  constructor(private modalService: ModalService) {}

  // Be aware, attachBrowserHistory true value will break redirection logic
  // https://neocles.slack.com/archives/C0154BZ7V7G/p1617874765000600
  public open(openObj: {
    message: string | TemplateRef<unknown> | ComponentFactory<unknown>;
    title?: string;
    hideFooter?: boolean;
    showCloseBtn?: boolean;
    options?: Partial<ModalOptions>;
    isUseDeleteConfirmButton?: boolean;
    showCancelButton?: boolean;
    confirmButtonText?: string;
  }) {
    const {
      message,
      title,
      hideFooter = false,
      showCloseBtn = false,
      options,
      isUseDeleteConfirmButton,
      showCancelButton = true,
      confirmButtonText,
    } = openObj;

    const confirmModalOption: Partial<ModalOptions> = {
      ...(options ?? {}),
      windowClass: overOverlayModalClass,
      backdropClass: overOverlayModalBackdropClass,
      attachBrowserHistory: (options ?? {}).attachBrowserHistory ?? true,
    };
    const modalRef = this.modalService.open(
      ConfirmationModalComponent,
      confirmModalOption,
    );

    modalRef.componentInstance.message = message;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.hideFooter = hideFooter;
    modalRef.componentInstance.showCloseBtn = showCloseBtn;
    modalRef.componentInstance.isUseDeleteConfirmButton =
      isUseDeleteConfirmButton;
    modalRef.componentInstance.showCancelButton = showCancelButton;
    modalRef.componentInstance.confirmButtonText = confirmButtonText;

    return modalRef.result.pipe(take(1));
  }
}
